module.exports = __webpack_public_path__ + "img/icon_h-station.fb22f7b2.png";